import { useEffect } from 'react';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Constants } from '@/constants/constants';
import { Util } from '@/utils/utils';
import { useNavigate } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { IEventDetailList } from '@/pages/customer-support/event/interface/event.interface';

const useEventDetail = () => {
	const navigate = useNavigate();
	const eventDetailInit = () => {
		eventDetailGetParams();
	};

	// 파라미터 가져오기
	const eventDetailGetParams = () => {
		const params = Util.getUrlParameter();
		const evntId = params.evntId;
		const endYn = params.endYn;
		if (!Util.isNullOrEmpty(evntId)) {
			eventDetailGetData(evntId, endYn);
		}
	};

	// 상세 정보 입력
	const eventDetailSetInfo = (content: IEventDetailList) => {
		const titleElement = document.querySelector('.board-detail .detail-head .title');
		if (titleElement) {
			titleElement.innerHTML = content.evntTitl || '';
		}

		const aplyStDt = Util.convertDate(content.aplyStDt, '.') || '';
		const aplyEdDt = content.aplyEdDt === '99991231' ? '별도 고지시' : Util.convertDate(content.aplyEdDt, '.') || '';

		const startElement = document.querySelector('.board-detail .detail-head .js-event-stDt');
		if (startElement) {
			startElement.innerHTML = aplyStDt;
		}

		const endElement = document.querySelector('.board-detail .detail-head .js-event-edDt');
		if (endElement) {
			endElement.innerHTML = aplyEdDt;
		}

		const eventCtntImg = Util.isNullOrEmpty(content.evntCtntImg)
			? Constants.empty
			: `<div>${content.evntCtntImg}</div>`;
		const eventCtnt = Util.isNullOrEmpty(content.evntCtnt) ? Constants.empty : content.evntCtnt;
		const ctnt = eventCtntImg + eventCtnt;

		const textBoxElement = document.querySelector('.board-detail .detail-body .text-box');
		if (textBoxElement) {
			textBoxElement.innerHTML = ctnt;
		}

		const nextBtn = document.querySelector('.detail-next-btn') as HTMLAnchorElement;
		const nextBtnTitle = document.querySelector('.detail-next-btn .title') as HTMLParagraphElement;
		if (nextBtn && nextBtnTitle) {
			eventDetailSetPrevNext(content, nextBtn, nextBtnTitle, true);
		}

		const prevBtn = document.querySelector('.detail-prev-btn') as HTMLAnchorElement;
		const prevBtnTitle = document.querySelector('.detail-prev-btn .title') as HTMLParagraphElement;
		if (prevBtn && prevBtnTitle) {
			eventDetailSetPrevNext(content, prevBtn, prevBtnTitle, false);
		}

		if (content.endYn === Constants.yes) {
			eventDetailEnded();
		}

		eventDetailShowContents();
	};

	// 이전 다음글 셋팅
	const eventDetailSetPrevNext = (
		content: IEventDetailList,
		btn: HTMLAnchorElement,
		title: HTMLParagraphElement,
		isNext: boolean
	) => {
		const className = isNext ? 'first' : 'last';
		const evntId = isNext ? content.nextEvntId : content.prevEvntId;
		const params = Util.getUrlParameter();
		const endYn = params.endYn;
		if (!Util.isNullOrEmpty(evntId)) {
			btn.addEventListener('click', (e: MouseEvent) => {
				e.preventDefault();

				navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}?evntId=${evntId}&endYn=${endYn}`);
			});
			title.innerHTML = isNext ? content.nextEvntTitl || '' : content.prevEvntTitl || '';
			title.classList.remove(className);
		} else {
			title.innerHTML = isNext ? '다음글이 없습니다.' : '이전글이 없습니다.';
			title.classList.add(className);
		}
	};

	// 종료된 이벤트
	const eventDetailEnded = () => {
		const title = document.querySelector('.board-detail .detail-head .title-tag');
		if (title) {
			title.innerHTML = '종료된 이벤트';
			title.classList.add('done');
		}
	};

	// 상세 데이터 조회
	const eventDetailGetData = async (evntId: string, endYn: string) => {
		try {
			const response = await Remote.Api.get(`${ApiConstant.mgmtEvent.detail}${evntId}/${endYn}/pc`, {});
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}
			const content = response.content;
			eventDetailSetInfo(content);
		} catch (error) {
			alert('이벤트 정보를 가져오는 중 오류가 발생했습니다.');
		}
	};

	// 컨텐츠 보여주기
	const eventDetailShowContents = () => {
		const contentElement = document.querySelector('.event .sub-content');
		const footerElement = document.querySelector('.footer');

		if (contentElement) {
			contentElement.classList.remove('hidden');
		}
		if (footerElement) {
			footerElement.classList.remove('hidden');
		}
	};
	useEffect(() => {
		eventDetailInit();
		window.scrollTo(0, 0);
	}, [Util.getUrlParameter()]);
};

export default useEventDetail;
